import React from "react";
import Box from "@mui/joy/Box";
import Card from "@mui/joy/Card";
import Grid from "@mui/joy/Grid";
import CardOverflow from "@mui/joy/CardOverflow";
import AspectRatio from "@mui/joy/AspectRatio";
import Input from "@mui/joy/Input";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import FormHelperText from "@mui/joy/FormHelperText";
import CardContent from "@mui/joy/CardContent";
import Checkbox from "@mui/joy/Checkbox";
import Typography from "@mui/joy/Typography";
import Button from "@mui/joy/Button";
import GoogleIcon from "@mui/icons-material/Google";
import FacebookIcon from "@mui/icons-material/Facebook";
import Stepper from "@mui/joy/Stepper";
import Step from "@mui/joy/Step";
import Textarea from "@mui/joy/Textarea";
import Calendario from "../pagina-principal/crearaventura/subcomponentesaventura/datepicker.jsx";
import Autocomplete from "@mui/joy/Autocomplete";
import Key from "@mui/icons-material/Key";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { getCities, getCountries } from "countries-cities";
import { getCountryCallingCode } from "libphonenumber-js";
import { getCode } from "country-list";
import Link from "@mui/joy/Link";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import axios from "axios";
import Alert from "@mui/joy/Alert";
import ErrorIcon from "@mui/icons-material/Error";
import LandscapeIcon from "@mui/icons-material/Landscape";

import { useNavigate } from "react-router-dom";

import imageCompression from "browser-image-compression";
import heic2any from "heic2any";

import "../css/registro.css";

export default function Registro() {
  let [pasoActual, setpasoActual] = React.useState(0);
  let [estadoBotonsiguiente, setEstadoBotonsiguiente] = React.useState(false);
  let [estadoBotonretroceder, setEstadoBotonretroceder] = React.useState(true);
  let [botonestado, setbotonestado] = React.useState(false);
  let [fecha, setfecha] = React.useState(null);
  let generos = ["Femenino", "Masculino", "Otros"];
  let [paises, setpaises] = React.useState(getCountries());
  let [prefijopais, setPrefijopais] = React.useState();
  let [ciudades, setciudades] = React.useState(getCities("Chile"));
  let [visibilidadpassword, setvisibilidadpassword] =
    React.useState("password");
  let [vistaPrevia, setVistaPrevia] = React.useState(null);
  let [actividades, setActividades] = React.useState([]);
  let [intereses, setInteresespersonales] = React.useState();
  let navigate = useNavigate();
  let url = process.env.REACT_APP_FRONTEND_URL;
  let logo = url + "/uploads/logo.svg";
  let [contenidoAlerta, setcontenidoAlerta] = React.useState({
    color: "",
    startDecorator: "",
    contenido: "",
    estado: false,
  });

  let [datosFormulario, setDatosFormulario] = React.useState({
    nombre: "",
    fecha_de_nacimiento: "",
    genero: "",
    telefono: "",
    correo: "",
    ciudad: "",
    pais: "",
    foto_de_perfil: "",
    descripcionperfil: "",
    contrasena: "",
    queBuscas: "",
    actividades: [],
    prefijo: "",
  });

  /* ENVIO INFO AL BACKEND */

  const EnviarRegistro = async () => {
    try {
      const formData = new FormData();

      // Agrega todos los campos excepto la galería
      for (const [key, value] of Object.entries(datosFormulario)) {
        if (key === "foto_de_perfil" && value) {
          formData.append("fotoPerfil", value); // Cambiar al nombre esperado
        } else if (Array.isArray(value)) {
          // Si es un array (como actividades), agrega cada elemento como un valor separado
          value.forEach((item) => {
            formData.append("actividades[]", item); // Usamos [] para indicar que es un array
          });
        } else {
          formData.append(key, value);
        }
      }

      const respuesta = await axios.post(url + "/api/registro", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      console.log("Usuario registrado:", respuesta.data);
      setcontenidoAlerta({
        color: "success",
        startDecorator: <LandscapeIcon />,
        contenido: "Bienvenido a AmigOutdoors",
        estado: true,
      });
      setTimeout(() => {
        navigate("/iniciar-sesion");
      }, 30000);
      navigate("/iniciar-sesion");
    } catch (error) {
      setcontenidoAlerta({
        color: "danger",
        startDecorator: <ErrorIcon />,
        contenido: "Por favor, completa todos los campos",
        estado: true,
      });
      setTimeout(() => {
        setcontenidoAlerta({ estado: false });
        setbotonestado(false);
      }, 3000);
      console.error("Error al registrar usuario:", error);
    }
  };
  /* ENVIO INFO AL BACKEND */

  /* RECOJER ACTIVIDADES LISTADO */

  React.useEffect(() => {
    let recojerinformacion = async () => {
      let getaventura = await axios.get(url + "/api/categorias");
      let actividades = getaventura.data.map(
        (informacion) => informacion.nombre_categoria
      );
      setActividades(actividades);
    };
    recojerinformacion();
  }, []);

  /* RECOJER ACTIVIDADES LISTADO */

  /* RECOJER INTERESES PERSONALES LISTADO */

  React.useEffect(() => {
    let recojerinformacion = async () => {
      let intereses = await axios.get(url + "/api/intereses-personales");
      let alternativas = intereses.data.map(
        (value) => value.nombre_interes_personal
      );
      setInteresespersonales(alternativas);
    };
    recojerinformacion();
  }, []);

  /* RECOJER INTERESES PERSONALES LISTADO */

  /* VALIDACION LO HIZO CHATGPT */

  React.useEffect(() => {
    if (pasoActual === 0) {
      setEstadoBotonsiguiente(
        !(
          datosFormulario.nombre.trim() !== "" &&
          /\S+@\S+\.\S+/.test(datosFormulario.correo)
        )
      );
    } else if (pasoActual === 1) {
      setEstadoBotonsiguiente(
        !(datosFormulario.fecha_de_nacimiento && datosFormulario.genero)
      );
    } else if (pasoActual === 2) {
      setEstadoBotonsiguiente(
        !(
          datosFormulario.telefono.trim() !== "" &&
          datosFormulario.pais &&
          datosFormulario.ciudad
        )
      );
    } else if (pasoActual === 3) {
      setEstadoBotonsiguiente(
        !(datosFormulario.descripcionperfil.trim() !== "")
      );
    } else if (pasoActual === 4) {
      setEstadoBotonsiguiente(
        datosFormulario.actividades.length > 0 && datosFormulario.queBuscas
          ? false
          : true
      );
    } else if (pasoActual === 5) {
      setEstadoBotonsiguiente(!(datosFormulario.contrasena.trim().length >= 6));
    }
  }, [pasoActual, datosFormulario]);
  /* VALIDACION LO HIZO CHATGPT */

  /* SUBIR FOTO LO HIZO CHATGPT  JUNTO CON COMPRESION DE IMAGEN Y CONVERSIÓN DE ARCHIVO*/

  const manejarSubirFoto = async (event) => {
    const archivo = event.target.files[0];
    if (archivo) {
      let opciones = {
        maxSizeMB: 1, // Máximo 1MB
        maxWidthOrHeight: 1024, // Redimensionar si es necesario
        useWebWorker: true,
      };
      try {
        let imagenRecibida = archivo;
        /* EN CASO DE ARCHIVOS .HEIC */

        if (
          imagenRecibida.type === "image/heic" ||
          imagenRecibida.type === "image/heif"
        ) {
          let blob = await heic2any({
            blob: archivo,
            toType: "image/jpeg",
            quality: 0.8,
          });
          imagenRecibida = new File([blob], "imagen_convertida.jpg", {
            type: "image/jpeg",
          });
        }

        /* EN CASO DE ARCHIVOS .HEIC */

        let imagenComprimida = await imageCompression(imagenRecibida, opciones);

        // Convertir a JPG si el formato es diferente
        const imagenBlob = await imageCompression(imagenComprimida, {
          fileType: "image/jpeg",
        });

        // Crear un nuevo archivo JPG
        const imagenJPG = new File([imagenBlob], "imagen.jpg", {
          type: "image/jpeg",
        });

        setDatosFormulario((valoranterior) => ({
          ...valoranterior,
          foto_de_perfil: imagenJPG,
        }));
        setVistaPrevia(URL.createObjectURL(imagenJPG));
      } catch (err) {
        console.log("Tenemos un error para procesar la fotografía " + err);
      }
    }
  };

  React.useEffect(() => {
    return () => {
      if (vistaPrevia) {
        URL.revokeObjectURL(vistaPrevia);
      }
    };
  }, [vistaPrevia]);
  /* SUBIR FOTO LO HIZO CHATGPT  JUNTO CON COMPRESION DE IMAGEN Y CONVERSIÓN DE ARCHIVO*/

  /* POPUP */

  let popup = () => {
    return (
      <Alert
        variant="soft"
        className="notificacion"
        color={contenidoAlerta.color}
        startDecorator={contenidoAlerta.startDecorator}
      >
        {contenidoAlerta.contenido}
      </Alert>
    );
  };

  /* POPUP */

  let loginRedSocial = () => {
    return (
      <div>
        <Button
          variant="soft"
          color="neutral"
          sx={{ width: "80%", marginBottom: "1rem" }}
          startDecorator={<GoogleIcon />}
        >
          Continuar con Google
        </Button>
        <Button
          variant="soft"
          color="neutral"
          sx={{ width: "80%" }}
          startDecorator={<FacebookIcon />}
        >
          Continuar con Facebook
        </Button>
      </div>
    );
  };

  return (
    <Box sx={{ display: "flex", height: "100vh" }} className="fondoregistro">
      {contenidoAlerta.estado ? popup() : null}
      <Grid
        container
        spacing={2}
        sx={{ width: "100%", justifyContent: "center" }}
      >
        <Grid
          xs={12}
          sm={6}
          md={4}
          sx={{
            display: "flex",
            flexDirection: "column", // Para organizar los hijos verticalmente
            alignItems: "center", // Centra horizontalmente
            justifyContent: "center", // Centra verticalmente
            height: "100%", // Hace que el Grid ocupe todo el espacio del contenedor
          }}
        >
          <Card
            variant="plain"
            size="lg"
            sx={{ width: "80%", paddingTop: "10%", paddingBottom: "10%" }}
          >
            <CardOverflow
              sx={{
                display: "flex",
                alignContent: "center",
                alignItems: "center",
                marginBottom: "1rem",
              }}
            >
              <AspectRatio
                variant="plain"
                ratio="1"
                sx={{
                  width: "100px",
                  marginBottom: "2rem",
                  borderRadius: "12px",
                }}
              >
                <img src={logo} alt="logo" style={{ objectFit: "contain" }} />
              </AspectRatio>
              <Typography
                level="h3"
                sx={{
                  marginBottom: "2rem",
                  display: "flex",
                  alignContent: "left",
                  alignItems: "left",
                }}
              >
                Registro
              </Typography>
            </CardOverflow>
            <CardContent>
              {pasoActual === 0 && (
                <FormControl>
                  <FormLabel>Nombre</FormLabel>
                  <Input
                    value={datosFormulario.nombre}
                    variant="outlined"
                    size="md"
                    onChange={(valor) => {
                      setDatosFormulario((valoranterior) => ({
                        ...valoranterior,
                        nombre: valor.target.value,
                      }));
                    }}
                  ></Input>
                  <FormHelperText sx={{ marginBottom: "1rem" }}>
                    Puedes escribir tu nombre completo o solo tu primer nombre.
                  </FormHelperText>
                  <FormLabel>Correo Electrónico</FormLabel>
                  <Input
                    value={datosFormulario.correo}
                    type="email"
                    variant="outlined"
                    size="md"
                    sx={{ marginBottom: "1rem" }}
                    onChange={(valor) => {
                      console.log(datosFormulario);
                      setDatosFormulario((valoranterior) => ({
                        ...valoranterior,
                        correo: valor.target.value,
                      }));
                    }}
                  ></Input>
                </FormControl>
              )}

              {pasoActual === 1 && (
                <div>
                  <FormControl>
                    <FormLabel>¿Cuál es tu fecha de nacimiento?</FormLabel>
                    <Calendario
                      modoNacimiento={true}
                      onDateChange={(date) => {
                        setfecha(date);
                        setDatosFormulario((valoranteior) => ({
                          ...valoranteior,
                          fecha_de_nacimiento: date,
                        }));
                      }}
                    />
                  </FormControl>
                  <FormControl>
                    <FormLabel sx={{ marginTop: "1rem" }}>
                      ¿Cuál es tu género?
                    </FormLabel>

                    <Autocomplete
                      value={datosFormulario.genero}
                      disableClearable
                      sx={{ marginBottom: "1rem" }}
                      options={generos}
                      onChange={(event, value) => {
                        console.log(value); // Aquí obtienes el género seleccionado
                        setDatosFormulario((valoranterior) => ({
                          ...valoranterior,
                          genero: value, // Guardas el género seleccionado directamente
                        }));
                      }}
                    />
                  </FormControl>
                </div>
              )}

              {pasoActual === 2 && (
                <FormControl>
                  <FormLabel>¿En qué país te encuentras?</FormLabel>
                  <Autocomplete
                    value={datosFormulario.pais}
                    options={paises}
                    disableClearable
                    sx={{ marginBottom: "1rem" }}
                    onChange={(event, value) => {
                      try {
                        setciudades(getCities(value));
                        setPrefijopais(
                          "+" + getCountryCallingCode(getCode(value))
                        );
                        setDatosFormulario((valoranterior) => ({
                          ...valoranterior,
                          pais: value,
                          prefijo: getCountryCallingCode(getCode(value)),
                          ciudad: "",
                        }));
                      } catch (err) {
                        console.log("Tenemos un error");
                      }
                    }}
                  />

                  <FormLabel>¿En qué ciudad vives?</FormLabel>
                  <Autocomplete
                    disabled={datosFormulario.pais ? false : true}
                    value={datosFormulario.ciudad}
                    disableClearable
                    options={ciudades}
                    sx={{ marginBottom: "1rem" }}
                    onChange={(event, value) => {
                      console.log(value);
                      setDatosFormulario((valoranterior) => ({
                        ...valoranterior,
                        ciudad: value,
                      }));
                    }}
                  />
                  <FormLabel>¿Cuál es tu número de teléfono? </FormLabel>
                  <Input
                    disabled={datosFormulario.ciudad ? false : true}
                    startDecorator={
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <SmartphoneIcon sx={{ marginRight: 1 }} />
                        <Typography>{prefijopais}</Typography>
                      </div>
                    }
                    value={datosFormulario.telefono}
                    type="tel"
                    variant="outlined"
                    size="md"
                    sx={{ marginBottom: "1rem" }}
                    onChange={(valor) => {
                      console.log(datosFormulario);
                      setDatosFormulario((valoranterior) => ({
                        ...valoranterior,
                        telefono: valor.target.value,
                      }));
                    }}
                  ></Input>
                </FormControl>
              )}

              {pasoActual === 3 && (
                <FormControl>
                  <FormLabel>Sube tu foto de perfil</FormLabel>
                  {vistaPrevia && (
                    <div
                      style={{
                        marginBottom: "1rem",
                        display: "flex",
                        alignContent: "center",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src={vistaPrevia}
                        alt="Vista previa"
                        style={{
                          width: "100px",
                          height: "100px",
                          borderRadius: "12px",
                        }}
                      />
                    </div>
                  )}
                  <input
                    type="file"
                    accept="image/*"
                    id="subir-foto"
                    style={{ display: "none" }}
                    onChange={manejarSubirFoto}
                  />
                  <label htmlFor="subir-foto">
                    <Button
                      component="span"
                      variant="outlined"
                      color="neutral"
                      startDecorator={<CloudUploadIcon />}
                      sx={{ marginBottom: "1rem", width: "100%" }}
                    >
                      Subir Foto de Perfil
                    </Button>
                  </label>

                  <FormLabel>Describe tu perfil en pocas palabras</FormLabel>
                  <Textarea
                    value={datosFormulario.descripcionperfil}
                    minRows={3}
                    onChange={(event) => {
                      console.log("datosFormulario");
                      setDatosFormulario((valoranterior) => ({
                        ...valoranterior,
                        descripcionperfil: event.target.value,
                      }));
                    }}
                  />

                  <FormHelperText sx={{ marginBottom: "1rem" }}>
                    ¿Qué te gustaría que otros sepan sobre ti?
                  </FormHelperText>
                </FormControl>
              )}

              {pasoActual === 4 && (
                <FormControl>
                  <Typography>
                    ¿Qué actividades realizas o te interesan?
                  </Typography>
                  <Autocomplete
                    value={datosFormulario.actividades}
                    multiple
                    options={actividades}
                    onChange={(event, value) => {
                      setDatosFormulario((valoranterior) => ({
                        ...valoranterior,
                        actividades: value.slice(0, 3), // Limita directamente a las primeras 3 opciones
                      }));
                    }}
                  />
                  <FormHelperText>
                    Selecciona un máximo de 3 opciones
                  </FormHelperText>
                  <Typography sx={{ marginTop: "1rem" }}>
                    ¿Qué necesitas para tu próxima aventura?
                  </Typography>
                  <Autocomplete
                    value={datosFormulario.queBuscas}
                    options={intereses}
                    onChange={(event, value) => {
                      setDatosFormulario((valoranteior) => ({
                        ...valoranteior,
                        queBuscas: value,
                      }));
                    }}
                  ></Autocomplete>
                </FormControl>
              )}

              {pasoActual === 5 && (
                <FormControl>
                  <FormLabel>Crea una contraseña para tu cuenta</FormLabel>
                  <Input
                    endDecorator={
                      <VisibilityIcon
                        onClick={() => {
                          setvisibilidadpassword("text");
                          if (visibilidadpassword === "text") {
                            setvisibilidadpassword("password");
                          }
                        }}
                      />
                    }
                    value={datosFormulario.contrasena}
                    type={visibilidadpassword}
                    placeholder="Escriba su Contraseña"
                    startDecorator={<Key />}
                    variant="outlined"
                    size="md"
                    sx={{ marginBottom: "1rem" }}
                    onChange={(valor) => {
                      console.log(datosFormulario);
                      setDatosFormulario((valoranterior) => ({
                        ...valoranterior,
                        contrasena: valor.target.value,
                      }));
                    }}
                  ></Input>
                  <Box
                    sx={{
                      alignItems: "center",
                      alignContent: "center",
                      display: "flex",
                      gap: 1,
                    }}
                  >
                    <Checkbox checked={true} size="sm" disabled />
                    <Link href="https://amigoutdoors.com/terminos-condiciones">
                      <Typography level="body-sm">
                        Acepto los Términos y Condiciones
                      </Typography>
                    </Link>
                  </Box>
                </FormControl>
              )}
              <Grid
                container
                spacing={2}
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Grid
                  item
                  xs={6}
                  sx={{
                    width: "auto",
                    display: "flex",
                    alignContent: "left",
                    alignItems: "left",
                  }}
                >
                  <Button
                    disabled={estadoBotonretroceder}
                    color="neutral"
                    variant="plain"
                    onClick={() => {
                      if (pasoActual > 0) {
                        setpasoActual(pasoActual - 1);
                        if (pasoActual === 1) {
                          setEstadoBotonretroceder(true);
                        }
                        if (pasoActual === 5) {
                          setEstadoBotonsiguiente(false);
                        }
                      }
                    }}
                  >
                    Retroceder
                  </Button>
                </Grid>

                <Grid
                  item
                  xs={6}
                  sx={{
                    width: "auto",
                    display: "flex",
                    alignContent: "right",
                    alignItems: "right",
                  }}
                >
                  <Button
                    loading={botonestado}
                    disabled={estadoBotonsiguiente}
                    color="neutral"
                    variant="outlined"
                    onClick={async () => {
                      if (pasoActual < 5) {
                        setpasoActual(pasoActual + 1);
                        setEstadoBotonretroceder(false);
                        if (pasoActual === 4) {
                          setEstadoBotonsiguiente(true);
                        }
                      }
                      if (pasoActual === 5) {
                        console.log("aqui estoy");
                        setbotonestado(true);
                        await EnviarRegistro();
                      }
                    }}
                  >
                    {pasoActual === 5 ? "Crear Cuenta" : "Siguiente"}
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid
          item
          xs={6}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
          }}
        ></Grid>
      </Grid>
    </Box>
  );
}
